import { render, staticRenderFns } from "./ViewHistory.vue?vue&type=template&id=68005d1c&scoped=true&"
import script from "./ViewHistory.vue?vue&type=script&lang=js&"
export * from "./ViewHistory.vue?vue&type=script&lang=js&"
import style0 from "./ViewHistory.vue?vue&type=style&index=0&id=68005d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68005d1c",
  null
  
)

export default component.exports